import { linkGroups, unlinkGroups } from "@redux/index";
import { useState } from "react";
import Dropdown from "react-bootstrap/Dropdown";
import { useTranslation } from "react-i18next";
import { Button, IconDispatcher } from "shared/ui-basics";
import styled from "styled-components/macro";
import GroupDropdown from "./GroupDropdown";


export const BulkUpdateGroups = ({recordIds, recordType}) => {
	const { t } = useTranslation();

	const [show, setShow] = useState(false);
	const [selected, setSelected] = useState({ groups: [] });

	const handleToggle = (isOpen) => {
		setShow(isOpen);
	};

	const handleLink = (id) => {
		linkGroups({ groupIds: [id], recordIds, recordType });
		setSelected({ groups: [...(selected?.groups || []), id] });
	};

	const handleUnLink = (id) => {
		unlinkGroups({ groupIds: [id], recordIds, recordType });
		setSelected({ groups: selected.groups?.filter((id) => id !== id) });
	};

	return (
		<DropDownContainer drop="up" show={show} onToggle={handleToggle}>
			<Dropdown.Toggle id="dropdown-custom-components" as={Button} variant="light-bulk">
				<ActionContainer>
					<div className="me-2">{IconDispatcher("SHAPES")}</div>
					<div>{t("GROUP")}</div>
				</ActionContainer>
			</Dropdown.Toggle>
			<MenuContainer>
				<GroupDropdown object={selected} link={handleLink} unlink={handleUnLink} isOpen={true} isSwitchDisabled={true} menuListHeight="244" />
			</MenuContainer>
		</DropDownContainer>
	);
};

BulkUpdateGroups.displayName = "BulkUpdateGroups";

const DropDownContainer = styled(Dropdown)`
	.dropdown-toggle::after {
		display: none;
	}
	.dropdown-menu {
		padding: 0px;
		margin: 0px;
	}
`;

const MenuContainer = styled(Dropdown.Menu)`
	width: 392px;
	height: 292px;
	transform: translate3d(0px, -54px, 0px) !important;
`;
const ActionContainer = styled.div`
	display: flex;
	align-items: center;
	font-size: 14px;

`;
